
import StanCard from './StanCard';
import slika1 from '../assets/slika1.jpeg';
import slika2 from '../assets/slika2.jpeg';
import slika3 from '../assets/slika3.jpeg';
import slika4 from '../assets/slika4.jpg';
import slika5 from '../assets/slika5.jpg';
import slika6 from '../assets/slika6.jpg';
import slika7 from '../assets/slika7.jpeg';
import slika8 from '../assets/slika8.jpeg';

const StanoviKupovina = ({ scrollToHome, onStanClick, stanoviKupovinaRef }) => { // Dodajemo stanoviKupovinaRef

  const stanoviData = [
    {
      id: 1,
      title: 'Novi Sad, Bulevar Evrope 20',
      location: 'Novi Sad, Bulevar Evrope 20',
      price: 120000,
      area: 50,
      rooms: 2,
      type: 'Stan',
      date: '19/08/24',
      sifra: 'A50-1234',
      kupatila: 1,
      garaza: 'Da',
      spratovi: 1,
      namena: 'Prodaja',
      namestenost: 'Polunamešten',
      parking: 'Da',
      images: [slika1, slika2, slika3],
    },
    {
      id: 2,
      title: 'Novi Sad, Novo Naselje 30',
      location: 'Novi Sad, Novo Naselje 30',
      price: 150000,
      area: 60,
      rooms: 3,
      type: 'Stan',
      date: '19/08/24',
      sifra: 'A50-5678',
      kupatila: 2,
      garaza: 'Ne',
      spratovi: 2,
      namena: 'Prodaja',
      namestenost: 'Prazan',
      parking: 'Ne',
      images: [slika5, slika6, slika4],
    },
    {
      id: 4,
      title: 'Beograd, Zemun 5',
      location: 'Beograd, Zemun 5',
      price: 220000,
      area: 85,
      rooms: 4,
      type: 'Kuća',
      date: '19/08/24',
      sifra: 'A50-6543',
      kupatila: 2,
      garaza: 'Da',
      spratovi: 2,
      namena: 'Prodaja',
      namestenost: 'Prazan',
      parking: 'Ne',
      images: [slika3, slika6, slika7],
    },
    {
      id: 3,
      title: 'Novi Sad, Novo Naselje 40',
      location: 'Novi Sad, Novo Naselje 40',
      price: 140000,
      area: 55,
      rooms: 2.5,
      type: 'Stan',
      date: '19/08/24',
      sifra: 'A50-7890',
      kupatila: 1,
      garaza: 'Da',
      spratovi: 1,
      namena: 'Prodaja',
      namestenost: 'Namešten',
      parking: 'Da',
      images: [slika7, slika8, slika2],
    },
    {
      id: 5,
      title: 'Beograd, Zemun 5',
      location: 'Beograd, Zemun 5',
      price: 220000,
      area: 85,
      rooms: 4,
      type: 'Kuća',
      date: '19/08/24',
      sifra: 'A50-6543',
      kupatila: 2,
      garaza: 'Da',
      spratovi: 2,
      namena: 'Prodaja',
      namestenost: 'Prazan',
      parking: 'Ne',
      images: [slika3, slika6, slika7],
    },
    {
      id: 6,
      title: 'Niš, Centar 10',
      location: 'Niš, Centar 10',
      price: 180000,
      area: 70,
      rooms: 3,
      type: 'Stan',
      date: '19/08/24',
      sifra: 'A50-2345',
      kupatila: 1,
      garaza: 'Ne',
      spratovi: 1,
      namena: 'Prodaja',
      namestenost: 'Polunamešten',
      parking: 'Da',
      images: [slika5, slika2, slika4],
    },
    {
      id: 7,
      title: 'Novi Sad, Bulevar Evrope 20',
      location: 'Novi Sad, Bulevar Evrope 20',
      price: 120000,
      area: 50,
      rooms: 2,
      type: 'Stan',
      date: '19/08/24',
      sifra: 'A50-1234',
      kupatila: 1,
      garaza: 'Da',
      spratovi: 1,
      namena: 'Prodaja',
      namestenost: 'Polunamešten',
      parking: 'Da',
      images: [slika1, slika2, slika3],
    },{
      id: 8,
      title: 'Beograd, Zemun 5',
      location: 'Beograd, Zemun 5',
      price: 220000,
      area: 85,
      rooms: 4,
      type: 'Kuća',
      date: '19/08/24',
      sifra: 'A50-6543',
      kupatila: 2,
      garaza: 'Da',
      spratovi: 2,
      namena: 'Prodaja',
      namestenost: 'Prazan',
      parking: 'Ne',
      images: [slika3, slika6, slika7],
    },
    {
      id: 9,
      title: 'Niš, Centar 10',
      location: 'Niš, Centar 10',
      price: 180000,
      area: 70,
      rooms: 3,
      type: 'Stan',
      date: '19/08/24',
      sifra: 'A50-2345',
      kupatila: 1,
      garaza: 'Ne',
      spratovi: 1,
      namena: 'Prodaja',
      namestenost: 'Polunamešten',
      parking: 'Da',
      images: [slika5, slika2, slika4],
    },
    {
      id: 10,
      title: 'Novi Sad, Bulevar Evrope 20',
      location: 'Novi Sad, Bulevar Evrope 20',
      price: 120000,
      area: 50,
      rooms: 2,
      type: 'Stan',
      date: '19/08/24',
      sifra: 'A50-1234',
      kupatila: 1,
      garaza: 'Da',
      spratovi: 1,
      namena: 'Prodaja',
      namestenost: 'Polunamešten',
      parking: 'Da',
      images: [slika1, slika2, slika3],
    },{
      id: 11,
      title: 'Beograd, Zemun 5',
      location: 'Beograd, Zemun 5',
      price: 220000,
      area: 85,
      rooms: 4,
      type: 'Kuća',
      date: '19/08/24',
      sifra: 'A50-6543',
      kupatila: 2,
      garaza: 'Da',
      spratovi: 2,
      namena: 'Prodaja',
      namestenost: 'Prazan',
      parking: 'Ne',
      images: [slika3, slika6, slika7],
    },
    {
      id: 12,
      title: 'Niš, Centar 10',
      location: 'Niš, Centar 10',
      price: 180000,
      area: 70,
      rooms: 3,
      type: 'Stan',
      date: '19/08/24',
      sifra: 'A50-2345',
      kupatila: 1,
      garaza: 'Ne',
      spratovi: 1,
      namena: 'Prodaja',
      namestenost: 'Polunamešten',
      parking: 'Da',
      images: [slika5, slika2, slika4],
    },

    // Dodaj više stanova ako je potrebno...
  ];

  // Klik na stan
  const handleStanClick = (stan) => {
    onStanClick(stan); // Poziva onStanClick iz App.js
  };

  return (
    <section ref={stanoviKupovinaRef} className="w-full h-auto bg-gray-900 text-gray-900 overflow-hidden pt-24"> {/* Koristimo stanoviKupovinaRef */}
      <h2 className="text-2xl text-pink-500 font-bold text-center md:text-left mt-8 mb-8 ml-0 md:ml-28">
      Najpopularnije za prodaju
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mr-8 ml-8">
        {stanoviData.map((stan) => (
          <StanCard
            key={stan.id}
            title={stan.title}
            location={stan.location}
            price={stan.price}
            area={stan.area}
            rooms={stan.rooms}
            type={stan.type}
            date={stan.date}
            images={stan.images}
            onClick={() => handleStanClick(stan)}  // Klik na stan
          />
        ))}
      </div>
      <div className="text-center mt-8">
        <button
          onClick={scrollToHome}
          className="bg-pink-700 text-white py-3 px-6 rounded-full hover:bg-pink-800 hover:text-black transition-colors duration-300 mb-8 shadow-md hover:shadow-[0_0_10px_3px_rgba(219,39,119,1)] transform hover:scale-105 text-sm font-medium"
        >
          Početna
        </button>
      </div>
    </section>
  );
};

export default StanoviKupovina;
